import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { Navbar } from "./components/navbar.jsx";
import { Shop } from "./pages/shop/shop.jsx";
import { Shop2 } from "./pages/shop2/shop2.jsx";
import { Shop3 } from "./pages/shop3/shop3.jsx";
import { Contact } from "./pages/contact.jsx";
import { Cart } from "./pages/cart/cart.jsx";
import Slideshow from "./pages/slide/Slideshow.js";
import { ShopContextProvider } from "./context/shop-context.jsx";
import "./App.css";

// Buat komponen terpisah yang menggunakan useLocation
const SlideshowWrapper = () => {
  const location = useLocation();

  // List path yang diizinkan untuk menampilkan slideshow
  const allowedPaths = ["/", "/Drinks", "/Snacks"];

  // Periksa apakah path saat ini diizinkan untuk menampilkan slideshow
  const shouldShowSlideshow = allowedPaths.includes(location.pathname);

  if (shouldShowSlideshow) {
    return <Slideshow />;
  } else {
    return null;
  }
};

function App() {
  return (
    <div className="App">
      <ShopContextProvider>
        <Router>
          <Navbar />
          <SlideshowWrapper /> 
          <Routes>
            <Route path="/" element={<Shop />} />
            <Route path="/Drinks" element={<Shop2 />} />
            <Route path="/Snacks" element={<Shop3 />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/cart" element={<Cart />} />
          </Routes>
        </Router>
      </ShopContextProvider>
    </div>
  );
}

export default App;
